export enum JourneyStepEntityEnum {
  ARTICLE = "Content",
  FAQ = "Question",
}
